

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBHEzlI2G2WdAJvGhI0TQY7OWZ--miDISk",
    authDomain: "seek2lrn-9f099.firebaseapp.com",
    projectId: "seek2lrn-9f099",
    storageBucket: "seek2lrn-9f099.appspot.com",
    messagingSenderId: "736622072211",
    appId: "1:736622072211:web:9b6d2d3f11aed470cc5866",
    measurementId: "G-EWYMG1JLPE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();



